// Lib
import { useDispatch } from 'react-redux';
import { List } from 'immutable';

// Utils
import { getTags } from '../../../../../../../common/elements/utils/elementPropertyUtils';

// Actions
import { addTagToElements, removeTagFromElements } from '../../../../../../element/tags/elementTagActions';
import { createAndAddTagToElementsThunk } from '../tagThunks';
import { addRootToTag } from '../../../../../../../common/tags/tagActions';

// Types
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { TagsToolContentProps } from '../TagsToolContent';
import { getCurrentContextRootId } from '../tagUtils';

type ReturnType = {
    handleToggleTagSelection: (tag: Tag) => void;
    handleCreateTag: (rootBoardId?: string) => void;
    handleCreateCopyAndAddToElement: (tag: Tag) => void;
};

const useTagHandlers = (
    props: TagsToolContentProps,
    searchString: string,
    setSearchString: (searchString: string) => void,
    elements: List<ImMNElement>,
): ReturnType => {
    const { currentBoardId, selectedElements, currentUserId, closePopup, shareRootPath } = props;

    const dispatch = useDispatch();

    const handleAddTagToElement = (tag: Tag) => {
        if (!getCurrentContextRootId(tag, shareRootPath)) {
            dispatch(addRootToTag(tag, currentBoardId));
        }

        dispatch(addTagToElements(elements, tag.id));
    };

    const handleToggleTagSelection = (tag: Tag) => {
        if (elements.every((element) => getTags(element)?.includes(tag.id))) {
            dispatch(removeTagFromElements(elements, tag.id));
        } else {
            handleAddTagToElement(tag);
        }

        // If the user is filtering the tags close the popup when they select a tag
        if (searchString) closePopup();
    };

    const handleCreateTag = (rootBoardId = currentBoardId) => {
        if (!searchString) return;

        const tagData = {
            name: searchString,
            rootBoardIds: [rootBoardId],
            creator: currentUserId,
        };

        dispatch(createAndAddTagToElementsThunk(tagData, selectedElements));

        setSearchString('');
        closePopup();
    };

    const handleCreateCopyAndAddToElement = (tag: Tag) => {
        const { name, color } = tag;
        const tagData = {
            name,
            color,
            rootBoardIds: [currentBoardId],
            creator: currentUserId,
        };

        dispatch(createAndAddTagToElementsThunk(tagData, selectedElements));
    };

    return {
        handleToggleTagSelection,
        handleCreateTag,
        handleCreateCopyAndAddToElement,
    };
};

export default useTagHandlers;
